import axios, { AxiosRequestConfig } from 'axios';
import { SWRConfiguration } from 'swr';
import { CacheLookupPolicy } from '@azure/msal-browser';
import { loginRequest, msalInstance } from './config/authConfig';

const fetcher = (url: string, config: AxiosRequestConfig) => axios.get(url, config).then((res) => res.data);

export const acquireTokenSilent = async () => {
  const accounts = msalInstance.getAllAccounts();
  const tokenRequest = {
    account: accounts[0],
    scopes: loginRequest.scopes,
    forceRefresh: false,
    cacheLookupPolicy: CacheLookupPolicy.Default, // will default to CacheLookupPolicy.Default if omitted
  };

  try {
    const response = await msalInstance.acquireTokenSilent(tokenRequest);
    return response;
  } catch (error) {
    // since this is outside of MSAL Context provider we shoud not be redirecting
    //   if (error instanceof InteractionRequiredAuthError) {
    //     await msalInstance.acquireTokenRedirect(tokenRequest);
    // }
    console.error(error);
  }
};

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
        
    if (401 === error.response.status && !originalRequest._retry) {
      originalRequest._retry = true;

      const response = await acquireTokenSilent();
      const token = `Bearer ${response?.accessToken}`;
      originalRequest.headers = originalRequest.headers ?? {};
      // setting token to existing request if token is expired
      originalRequest.headers.Authorization = token;
      // setting global axios token after for subsequent requests
      axios.defaults.headers.common['Authorization'] = token;

      return await axios(originalRequest);
    }
    return Promise.reject(error);
  }
);

export const swrConfig: SWRConfiguration = {
  fetcher,
  revalidateOnFocus: false,
  revalidateIfStale: false,
  shouldRetryOnError: false,
  revalidateOnMount: true,
};
